<template>
  <div class="w-full pt-6 sm:pr-5 pr-2 lg:pl-0 sm:pl-5 pl-2" v-if="loaded">
    <div class="flex justify-end items-center mb-5">
      <div class="mr-4">
        <button class="bg-white rounded-[4px] h-[41px] w-[42px] mt-1">
          <svg
            width="42"
            height="42"
            viewBox="0 0 42 42"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              y="0.220703"
              width="41.9894"
              height="41.7476"
              rx="4"
              fill="white"
            />
            <path
              d="M19.3949 28.2537C19.186 28.2532 18.9855 28.1726 18.835 28.0287C18.7583 27.9547 18.6975 27.866 18.6562 27.768C18.615 27.67 18.5941 27.5647 18.595 27.4585V21.8225L13.1784 15.2387C13.0818 15.1222 13.0209 14.9807 13.0028 14.8309C12.9846 14.6811 13.01 14.5292 13.076 14.3933C13.14 14.2573 13.2418 14.1423 13.3693 14.0618C13.4968 13.9814 13.6448 13.9388 13.7959 13.9392H28.1933C28.3447 13.9392 28.4929 13.982 28.6209 14.0624C28.7488 14.1429 28.8511 14.2578 28.9159 14.3939C28.9808 14.5299 29.0055 14.6814 28.9871 14.8308C28.9688 14.9802 28.9082 15.1213 28.8124 15.2379L23.3941 21.8225V25.868C23.3946 26.0159 23.3534 26.1609 23.275 26.2866C23.1967 26.4123 23.0844 26.5136 22.951 26.5789L19.7516 28.1695C19.6409 28.2249 19.5188 28.2537 19.3949 28.2537ZM15.4852 15.5297L20.0155 21.0352C20.1317 21.1773 20.1949 21.3548 20.1947 21.5378V26.1718L21.7944 25.3765V21.5378C21.7945 21.3543 21.8583 21.1765 21.9752 21.0344L26.5072 15.5297H15.4852Z"
              fill="#9295A3"
            />
          </svg>
        </button>
      </div>
      <div class="mr-4">
        <button
          id="dropdownDividerButton"
          data-dropdown-toggle="dropdownDivider"
          class="text-[rgba(4,4,4,1)] bg-white focus:ring-0 focus:outline-none focus:ring-transparent font-[MontMedium] rounded-[4px] text-sm pl-5 text-center inline-flex items-center"
          type="button"
        >
          <span class="text-xs text-[rgba(146,149,163,1)] mr-2">Sort by:</span>
          All Categories
          <span
            class="border-l border-l-[rgba(241,241,245,1)] h-[40px] flex-all-center pl-2 pr-1 ml-3"
          >
            <svg
              width="12"
              height="7"
              viewBox="0 0 9 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.62643 0.59082C7.70088 0.590926 7.77378 0.611912 7.83676 0.651367C7.89975 0.690822 7.95025 0.747145 7.98248 0.813862C8.01471 0.88058 8.02736 0.954985 8.01896 1.02853C8.01056 1.10207 7.98146 1.17176 7.93501 1.2296L4.53827 5.45167C4.50121 5.49775 4.45419 5.53495 4.40071 5.56052C4.34722 5.58608 4.28864 5.59936 4.2293 5.59936C4.16995 5.59936 4.11137 5.58608 4.05788 5.56052C4.0044 5.53495 3.95738 5.49775 3.92032 5.45167L0.523578 1.2296C0.477084 1.17171 0.447977 1.10194 0.439609 1.02833C0.431241 0.954719 0.443952 0.880254 0.476278 0.813508C0.508604 0.746762 0.559231 0.69045 0.622331 0.651053C0.685431 0.611656 0.758438 0.590778 0.832948 0.59082L7.62643 0.59082Z"
                fill="#9295A3"
              />
            </svg>
          </span>
        </button>

        <!-- Dropdown menu -->
        <div
          id="dropdownDivider"
          class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 dark:divide-gray-600"
        >
          <ul
            class="py-2 text-sm text-gray-700 dark:text-gray-200"
            aria-labelledby="dropdownDividerButton"
          >
            <li>
              <a
                href="#"
                class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                >All</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div>
        <button>
          <img
            src="../../../assets/images/s-dashboard/Category.png"
            alt="Category"
          />
        </button>
      </div>
    </div>

    <div
      class="bg-teal-100 border border-teal-400 text-teal-700 px-4 py-3 rounded relative"
      role="alert"
      v-if="courses.data.length < 1"
    >
      <span class="block sm:inline">No courses found</span>
    </div>

    <div
      class="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-4 pb-10"
      v-else
    >
      <!--------Grid 1--------------->
      <div v-for="(item, index) in courses.data" :key="index">
        <router-link :to="{ name: 'course', params: { id: item.uuid } }">
          <div class="h-auto bg-white w-[100%] rounded-sm pl-4 pt-5 pb-1 pr-5">
            <div class="flex justify-between items-center">
              <div class="mr-4 sm:w-[50px] w-[35px] mb-2">
                <img :src="item.image" alt="grph-design" />
              </div>
              <svg
                width="16"
                height="3"
                viewBox="0 0 16 3"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 3C2.82843 3 3.5 2.32843 3.5 1.5C3.5 0.671573 2.82843 0 2 0C1.17157 0 0.5 0.671573 0.5 1.5C0.5 2.32843 1.17157 3 2 3Z"
                  fill="#9295A3"
                />
                <path
                  d="M8 3C8.82843 3 9.5 2.32843 9.5 1.5C9.5 0.671573 8.82843 0 8 0C7.17157 0 6.5 0.671573 6.5 1.5C6.5 2.32843 7.17157 3 8 3Z"
                  fill="#9295A3"
                />
                <path
                  d="M14 3C14.8284 3 15.5 2.32843 15.5 1.5C15.5 0.671573 14.8284 0 14 0C13.1716 0 12.5 0.671573 12.5 1.5C12.5 2.32843 13.1716 3 14 3Z"
                  fill="#9295A3"
                />
              </svg>
            </div>
            <div class="mb-2">
              <p class="text-[rgba(4,4,4,1)] font-[MontMedium] text-base">
                {{ item.title }}
              </p>
            </div>
            <div class="flex justify-start items-center mb-3">
              <div
                class="w-[27px] h-[27px] bg-[rgba(196,196,196,1)] rounded-full mr-2"
              ></div>
              <p class="font-[MontMedium] text-xs text-[rgba(146,149,163,1)]">
                {{ item.teacher.firstname }} {{ item.teacher.lastname }}
              </p>
            </div>
            <div class="flex flex-wrap mb-8">
              <div class="flex justify-start items-center mr-4">
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 15 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.75 1C8.95513 1 7.5 1.75731 7.5 2.69231C7.5 1.75731 6.04487 1 4.25 1C2.45513 1 1 1.75731 1 2.69231V12C1 11.065 2.45513 10.3077 4.25 10.3077C6.04487 10.3077 7.5 11.065 7.5 12C7.5 11.065 8.95513 10.3077 10.75 10.3077C12.5449 10.3077 14 11.065 14 12V2.69231C14 1.75731 12.5449 1 10.75 1Z"
                    stroke="#6AC9E7"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <p
                  class="font-[MontMedium] text-[rgba(146,149,163,1)] ml-2 text-xs"
                >
                  {{ item.modules.length }} Modules
                </p>
              </div>

              <div class="flex justify-start items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="26"
                  viewBox="0 0 24 26"
                  fill="none"
                >
                  <g clip-path="url(#clip0_2265_61566)">
                    <path
                      d="M22.1538 3.76921C22.1538 4.27883 22.0577 4.75479 21.8654 5.1971C21.6635 5.64902 21.399 6.04325 21.0721 6.37979C20.7067 6.73556 20.3125 6.99998 19.8894 7.17306C19.4471 7.36537 18.9712 7.46152 18.4615 7.46152C17.9615 7.46152 17.4808 7.36537 17.0192 7.17306C16.6058 6.99037 16.2163 6.72594 15.851 6.37979C15.4952 6.0144 15.2308 5.62017 15.0577 5.1971C14.8654 4.75479 14.7692 4.27883 14.7692 3.76921C14.7692 3.2596 14.8654 2.78364 15.0577 2.34133C15.2308 1.91825 15.4952 1.52402 15.851 1.15864C16.2163 0.812481 16.6058 0.548058 17.0192 0.365366C17.4808 0.173058 17.9615 0.0769043 18.4615 0.0769043C18.9712 0.0769043 19.4471 0.173058 19.8894 0.365366C20.3125 0.538443 20.7067 0.802866 21.0721 1.15864C21.399 1.49517 21.6635 1.8894 21.8654 2.34133C22.0577 2.78364 22.1538 3.2596 22.1538 3.76921ZM24 12.5529C24 12.9375 23.9231 13.2836 23.7692 13.5913C23.6154 13.8798 23.4087 14.1154 23.149 14.2981C22.8606 14.4904 22.5577 14.6298 22.2404 14.7163C21.9135 14.8029 21.5673 14.8461 21.2019 14.8461H19.2692C18.7692 14.2596 18.1971 13.8125 17.5529 13.5048C16.9279 13.1971 16.226 13.0288 15.4471 13C15.8221 12.4519 16.1106 11.8654 16.3125 11.2404C16.5144 10.625 16.6154 9.98075 16.6154 9.30767C16.6154 9.24998 16.613 9.16825 16.6082 9.06248C16.6034 8.95671 16.601 8.87979 16.601 8.83171C16.5817 8.62017 16.5625 8.46152 16.5433 8.35575C16.8125 8.4519 17.125 8.53364 17.4808 8.60094C17.8173 8.65864 18.1442 8.68748 18.4615 8.68748C18.9615 8.66825 19.4183 8.60575 19.8317 8.49998C20.3029 8.35575 20.6779 8.21633 20.9567 8.08171C21.2452 7.9471 21.5144 7.80287 21.7644 7.64902C21.9567 7.54325 22.1058 7.48075 22.2115 7.46152C22.5385 7.48075 22.7933 7.58171 22.976 7.7644C23.1779 7.93748 23.3462 8.19229 23.4808 8.52883C23.6154 8.80767 23.7212 9.15383 23.7981 9.56729C23.875 10.0961 23.9231 10.4759 23.9423 10.7067C23.9712 11.0913 23.9856 11.4471 23.9856 11.774C23.9952 11.9856 24 12.2452 24 12.5529ZM15.6923 9.30767C15.6923 10.0384 15.5481 10.7548 15.2596 11.4567C14.9712 12.1298 14.5721 12.7211 14.0625 13.2308C13.5337 13.75 12.9471 14.1442 12.3029 14.4134C11.6394 14.7019 10.9231 14.8461 10.1538 14.8461C9.38461 14.8461 8.66346 14.7019 7.99038 14.4134C7.36538 14.1442 6.77885 13.75 6.23077 13.2308C5.72115 12.7115 5.32692 12.1202 5.04808 11.4567C4.75962 10.7933 4.61538 10.0769 4.61538 9.30767C4.61538 8.53844 4.75962 7.8221 5.04808 7.15864C5.34615 6.46633 5.74038 5.87979 6.23077 5.39902C6.74038 4.8894 7.32692 4.49037 7.99038 4.2019C8.66346 3.91344 9.38461 3.76921 10.1538 3.76921C10.9231 3.76921 11.6394 3.91344 12.3029 4.2019C12.976 4.49037 13.5625 4.8894 14.0625 5.39902C14.5625 5.87017 14.9615 6.45671 15.2596 7.15864C15.5481 7.86056 15.6923 8.5769 15.6923 9.30767ZM20.3077 22.1875C20.2885 22.9856 20.125 23.6538 19.8173 24.1923C19.5096 24.7404 19.0625 25.1683 18.476 25.4759C17.8798 25.774 17.2067 25.9231 16.4567 25.9231H3.85096C3.09135 25.9231 2.41346 25.774 1.81731 25.4759C1.24038 25.1683 0.798077 24.7404 0.490385 24.1923C0.163462 23.6538 0 22.9856 0 22.1875C0 21.7163 0.0240385 21.1346 0.0721154 20.4423C0.139423 19.7692 0.235577 19.1538 0.360577 18.5961C0.504808 17.9231 0.6875 17.3365 0.908654 16.8365C1.15865 16.2596 1.46154 15.7596 1.81731 15.3365C2.20192 14.8846 2.64423 14.5433 3.14423 14.3125C3.64423 14.0721 4.25962 13.9423 4.99038 13.9231C5.10577 13.9423 5.25481 14.0144 5.4375 14.1394C5.70673 14.3125 5.95673 14.4759 6.1875 14.6298C6.42788 14.7836 6.77404 14.9808 7.22596 15.2211C7.62019 15.4231 8.0625 15.5865 8.55289 15.7115C8.98558 15.8365 9.51923 15.9086 10.1538 15.9279C10.7885 15.9086 11.3221 15.8365 11.7548 15.7115C12.2452 15.5865 12.6875 15.4231 13.0817 15.2211C13.5337 14.9808 13.8798 14.7836 14.1202 14.6298C14.2163 14.5625 14.4663 14.399 14.8702 14.1394C15.0529 14.0144 15.2019 13.9423 15.3173 13.9231C16.0481 13.9423 16.6587 14.0721 17.149 14.3125C17.649 14.5433 18.0962 14.8846 18.4904 15.3365C18.8558 15.7981 19.1587 16.2981 19.399 16.8365C19.6394 17.4038 19.8221 17.9904 19.9471 18.5961C20.0721 19.1538 20.1683 19.7692 20.2356 20.4423C20.2837 21.1346 20.3077 21.7163 20.3077 22.1875Z"
                      fill="#FF5374"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2265_61566">
                      <rect
                        width="24"
                        height="25.8462"
                        fill="white"
                        transform="translate(0 0.0769043)"
                      />
                    </clipPath>
                  </defs>
                </svg>

                <p
                  class="font-[MontMedium] text-[rgba(146,149,163,1)] ml-2 text-xs"
                >
                  {{ item.students_count }} Students
                </p>
              </div>

              <div class="flex justify-start items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="17"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clip-path="url(#clip0_3020_2410)">
                    <path
                      d="M15.75 9.75L21.8028 6.72361C22.4677 6.39116 23.25 6.87465 23.25 7.61803V16.382C23.25 17.1253 22.4677 17.6088 21.8028 17.2764L15.75 14.25"
                      stroke="#2A2B61"
                      stroke-width="2"
                      stroke-miterlimit="10"
                    />
                    <path
                      d="M14.25 19.5H2.25C1.85218 19.5 1.47064 19.342 1.18934 19.0607C0.908035 18.7794 0.75 18.3978 0.75 18V6C0.75 5.60218 0.908035 5.22064 1.18934 4.93934C1.47064 4.65804 1.85218 4.5 2.25 4.5H14.25C14.6478 4.5 15.0294 4.65804 15.3107 4.93934C15.592 5.22064 15.75 5.60218 15.75 6V18C15.75 18.3978 15.592 18.7794 15.3107 19.0607C15.0294 19.342 14.6478 19.5 14.25 19.5Z"
                      stroke="#2A2B61"
                      stroke-width="2"
                      stroke-miterlimit="10"
                      stroke-linecap="square"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3020_2410">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

                <p
                  class="font-[MontMedium] text-[rgba(146,149,163,1)] ml-2 text-xs"
                >
                  {{ calculateTotalVideos(item) }} Videos
                </p>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { initFlowbite } from "flowbite";
export default {
  name: "course",
  data() {
    return {
      courses: [],
      loaded: false,
    };
  },
  methods: {
    getCourses() {
      this.$store.commit("setLoader", true);
      this.$store
        .dispatch("get", "student/courses")
        .then((resp) => {
          this.$store.commit("setLoader", false);
          console.log(resp);
          this.courses = resp.data;
          this.loaded = true;
        })
        .catch((err) => {
          this.$store.commit("setLoader", false);
          this.$store.dispatch("handleError", err);
        });
    },
    calculateTotalVideos(course) {
      var total = 0;
      course.modules.forEach((item) => {
        total += item.videos.length;
      });
      return total;
    },
  },
  created() {
    initFlowbite();
    this.getCourses();
  },
};
</script>

<style scoped></style>
